import { useMemo } from 'react';

import { UserRole } from 'api/dtos/user';
import useGetCurrentEntity from 'hooks/useGetCurrentEntity';
import { useGetEntitiesQuery } from 'api/entityEndpoints';

const useGetUserPermission = () => {
    const currentEntity = useGetCurrentEntity();
    const userRole = currentEntity?.role;

    return useMemo(() => ({
        isOwner: userRole === UserRole.Owner,
        isAdmin: userRole === UserRole.Admin,
        isGuest: userRole === UserRole.Guest,
        isModerator: userRole === UserRole.Moderator,
        isTeamMember: userRole === UserRole.TeamMember,
    }), [userRole]);
};

export default useGetUserPermission;

export const useGetUserPermissionForEntityById = (entityId: string) => {
    const { data } = useGetEntitiesQuery();
    const entity = data?.find((e) => e.id === entityId);
    const userRole = entity?.role;

    return useMemo(() => ({
        isOwner: userRole === UserRole.Owner,
        isAdmin: userRole === UserRole.Admin,
        isGuest: userRole === UserRole.Guest,
        isModerator: userRole === UserRole.Moderator,
        isTeamMember: userRole === UserRole.TeamMember,
    }), [userRole]);
};
